{
  "comment": "Map models (M3 plan R9, spec §6.1). galaxy: node radii by knowledge, the label cap, the 'Avoid hostile' danger threshold and overlay colours (danger stops are [threshold, colour], ascending; a system takes the last stop at or below its danger). system: the log-radial projection (r' = radius × log10(1 + r/logR0M) / log10(1 + R/logR0M)), the y squash and icon sizes. camera: the map orbit camera (orbitSpeed rad per pointer pixel, padOrbitSpeed rad/s at full stick, zoomStep per wheel notch, focusRate 1/s).",
  "galaxy": {
    "nodeRadius": { "charted": 0.9, "rumoured": 0.6 },
    "labelMax": 40,
    "avoidDanger": 1.4,
    "colors": {
      "region": { "gate": "#E8C170", "mid": "#6FA3C8", "deep": "#9B7FD0", "rim": "#C0C8D0" },
      "danger": [[0.3, "#3FB871"], [1, "#E8C170"], [1.5, "#E07A3F"], [2, "#D04040"]],
      "online": "#9FD8FF",
      "offline": "#4A5566",
      "reboot": "#FFC04A",
      "route": "#FFFFFF"
    }
  },
  "system": {
    "logR0M": 1e8,
    "radius": 60,
    "yScale": 0.3,
    "iconSize": { "station": 1.2, "relay": 1.4, "poi": 1, "body": 1, "laneRing": 0.6, "field": 1, "star": 2 }
  },
  "camera": {
    "fovDeg": 50,
    "minDistance": 20,
    "maxDistance": 260,
    "orbitSpeed": 0.004,
    "padOrbitSpeed": 2.2,
    "zoomStep": 1.15,
    "maxPitchDeg": 85,
    "focusRate": 6
  }
}
